<template>
    <div :class="`${rowClass} h-100`">
      <div :class="`${colClass} h-100`">
        <div class="h-100">

            <b-card class="mb-3" v-if="block && (block.meta.searchFields && block.meta.searchFields.length > 0)">
                <b-form inline @submit.prevent>
                    <label class="sr-only" for="inline-form-input-name">{{ trans('keywords') }}</label>
                    <b-input
                        :placeholder="trans('keywords')"
                        v-model="search"
                        type="search"
                        style="width: 50%; max-width: auto;"
                        @input="searchOnChange($event)"
                        @keydown="onRequestKeydown"
                    />
                    <b-button variant="branded" class="ml-3" @click="fetch()">{{ trans('search') }}</b-button>
                </b-form>
                <b-badge
                    style="cursor: pointer"
                    :variant="selectedCategory == cat ? 'primary' : 'secondary'"
                    :class="index != 0 ? 'ml-2 mt-3' : 'mt-3'"
                    v-for="(cat, index) in categories"
                    :key="index"
                    pill
                    @click="onCatClick(cat)"
                >
                    {{ cat }}
                </b-badge>
            </b-card>
            <b-overlay :show="busy">
                <div v-for="(row, index) in paginatedItems" :key="index">
                    <div v-html="row.repeater" @click="onRowClick(row)" style="cursor: pointer;"></div>
                    <hr v-if="index != rows.length - 1">
                </div>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows.length"
                    :per-page="perPage"
                    @change="onPageChanged"
                    v-if="rows.length > perPage"
                ></b-pagination>
            </b-overlay>
        </div>
      </div>
        <b-modal
            id="single-modal"
            size="xl"
            :title="selectedRow.title"
            :ok-title="trans('close')"
            ok-only
            @hidden="updateUrl(true)"
            @shown="iframeCheck"
            :hide-backdrop="isInIframe"
        >
            <div v-html="selectedRow.single"></div>
        </b-modal>
    </div>
  </template>

  <script>
    export default {
      props: {
        organization: Object,
        page: Object,
        block: Object,
      },
      components: {
      },
      data() {
        return {
          trans: trans,
          busy: false,
          error: null,
          selectedRow: {},
          rows: [],
          paginatedItems: [],
          search: null,
          categories: [],
          selectedCategory: null,
          perPage: 10,
          currentPage: 1,
        }
      },
      computed: {
        rowClass() {
          return 'row'
        },
        colClass() {
          return 'col-12'
        },
        isInIframe() {
            return window !== window.parent
        }
      },
      watch: {
        block() {
          this.fetch()
        },
      },
      methods: {
        fetch(callback) {
            this.busy = true
            let url = `/org/${this.organization.id}/page/${this.page.upid}/form_answers/${this.block.id}`
            axios.get(url, {
                params: {
                    cat: this.selectedCategory,
                    search: this.search,
                }
            })
            .then(response => {
              this.busy = false
              this.rows = response.data.answers
              this.categories = response.data.categories && response.data.categories.values ? response.data.categories.values : []

              this.paginate(0)

              if (callback) {
                callback()
              }
            })
            .catch(error => {
              this.busy = false
              this.error = _.errorFromAjax(error)
            })
        },
        onRowClick(row) {
            if (!row.single) return
            this.selectedRow = row
            this.$bvModal.show('single-modal')
            this.updateUrl()
        },
        updateUrl(remove) {
            let query = !remove ? `?post_id=${this.selectedRow.id}` : ''
            window.history.replaceState(null, null, window.location.href.split('?')[0] + query)
        },
        iframeCheck() {
            if (window !== window.parent) {
                $('#' + this.modalId).css({top: this.yPos - 100})
            }
        },
        onCatClick(cat) {
            this.selectedCategory = this.selectedCategory == cat ? null : cat
            this.fetch()
        },
        paginate(currentPage) {
            this.paginatedItems = [...this.rows].slice(
                currentPage * this.perPage,
                (currentPage + 1) * this.perPage
            )
        },
        onPageChanged(page) {
            this.paginate(page - 1);
        },
        searchOnChange(e) {
            if (e == '') {
                this.fetch()
            }
        },
        onRequestKeydown(e) {
            if (e.keyCode == 13) this.fetch()
        },
      },
      mounted() {
        window.pageFromAnswersBlock = this
        this.fetch(() => {
            let urlParams = new URLSearchParams(window.location.search)
            let postId = urlParams.get('post_id')
            if (postId) {
                let row = this.rows.find(x => x.id == postId)
                this.onRowClick(row)
            }
        })
      },
    }
  </script>
